import React from 'react';
import { withTranslation } from 'react-i18next';
import { Button, Paper, PaperTitle, FormWrapper } from 'virtues-bootstrap';
import PropTypes from 'prop-types';
import { map } from 'ramda';

import DeviceStatusInfo from 'containers/DeviceStatusInfo/RolePatient';
import MedicalTherapyInfo from 'containers/MedicalTherapyInfo/RolePatient';

import { REGISTERED } from 'constants/observationStatuses';

import { ReactComponent as IconBattery } from 'svg/battery-three-quarters-solid.svg';
import { ReactComponent as IconBolt } from 'svg/bolt-solid.svg';
// import { ReactComponent as IconExclamationCircle } from 'svg/exclamation-circle-solid.svg';

import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';

import s from './styles.module.scss';

const ReportView = ({
  // alertValue,
  batteryLife,
  clinicName,
  deviceImplant,
  isRead,
  pacingValue,
  readDate,
  readTime,
  reportsMarkAsRead,
  shockValue,
  shocks,
  status,
  transmissionType,
  effectiveDateTime,
  t,
}) => (
  <Paper data-test="report">
    <PaperTitle withBorder>
      {t('reports.reportDetails')}
      <span className={s.effectiveDateTime}>{effectiveDateTime}</span>
    </PaperTitle>
    <div className={s.markAsReadContainer}>
      <Button
        id="markReportAsRead"
        className={s.markAsReadBtn}
        disabled={isRead}
        onClick={reportsMarkAsRead}
      >
        {t('reports.markReportAsRead')}
      </Button>
      {isRead && (
        <span className={s.readDate}>
          {t('dateTimeFormat.readOnResourceFormat', {
            date: readDate,
            time: readTime,
          })}
        </span>
      )}
    </div>
    <div className={s.reportType}>
      {t('reports.reportTypeAndDateMsg', {
        type: transmissionType,
        date: effectiveDateTime,
      })}
      <br />
      {t('reports.reportsReceivedByMsg', {
        clinic: clinicName,
      })}
    </div>
    <FormWrapper title={t('patient.deviceInformation')}>
      <AdaptiveDataRow
        iconClassName={s.iconStyle}
        title={t('reports.longevity')}
        icon={<IconBattery />}
      >
        <div style={{ color: batteryLife === 'The battery is at end of life' && 'red' }}>
          {batteryLife}
        </div>
      </AdaptiveDataRow>
      <AdaptiveDataRow title={t('reports.recordedShocks')} icon={<IconBolt />}>
        {map(
          ({ id, dateTime }) => (
            <div key={id}>{dateTime}</div>
          ),
          shocks,
        )}
      </AdaptiveDataRow>
      <AdaptiveDataRow title={t('reports.deviceParameters')}>
        <div>{t('reports.pacingSettingsText', { value: pacingValue })}</div>
        <div>{t('reports.patientBatteryLifeSettingsText', { value: batteryLife })}</div>
        {/ICD/i.test(deviceImplant) && (
          <>
            <div>{t('reports.pacingTherapySettingsText', { value: shockValue })}</div>
            <div>
              {t('reports.shockSettingsText', { value: shockValue || t('reports.notApplicable') })}
            </div>
          </>
        )}
      </AdaptiveDataRow>
    </FormWrapper>

    {status !== REGISTERED && (
      <>
        <DeviceStatusInfo />
        <MedicalTherapyInfo />
      </>
    )}
  </Paper>
);

ReportView.defaultProps = {
  readDate: null,
  readTime: null,
};

ReportView.propTypes = {
  // alertValue: PropTypes.bool.isRequired,
  batteryLife: PropTypes.string.isRequired,
  clinicName: PropTypes.string.isRequired,
  deviceImplant: PropTypes.string.isRequired,
  isRead: PropTypes.bool.isRequired,
  pacingValue: PropTypes.string.isRequired,
  readDate: PropTypes.string,
  readTime: PropTypes.string,
  reportsMarkAsRead: PropTypes.func.isRequired,
  shocks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      dateTime: PropTypes.string.isRequired,
    }),
  ).isRequired,
  shockValue: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  transmissionType: PropTypes.string.isRequired,
  effectiveDateTime: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ReportView);
